import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySeparator'
})
export class ArraySeparatorPipe implements PipeTransform {

  constructor() { }

  transform(value: any): string {

    if (!Array.isArray(value))
      return '';

    const uniqueArray = [...new Set(Array.from(value))]; // Remove duplicates

    return this.arrayToSentence(uniqueArray);
  } 

  arrayToSentence(arr: string[]): string {
    if (arr.length === 0) {
      return '';
    } else if (arr.length === 1) {
      return arr[0];
    } else if (arr.length === 2) {
      return `${arr[0]} y ${arr[1]}`;
    } else {
      const lastElement = arr.pop();
      return `${arr.join(', ')}, y ${lastElement}`;
    }
  }

}
